import React from "react";
import { SPOILER_TYPE, TIPTAP_FIGURE_TYPE, VIDEO_TYPE } from "./../ricos-content/index.js";
import { Node_Type } from "./../ricos-schema/legacy/wix/rich_content/v1/index.js";
import {
  decorateComponentWithProps,
  PLUGIN_TOOLBAR_BUTTON_ID
} from "./../editor-common/index.js";
import { getVisibleOnlyOnDesktopResolver } from "./../plugin-commons/index.js";
import {
  AlignmentPanel,
  DeleteButton,
  NodeAlignmentButton,
  NodeSizeButton,
  SizePanel
} from "./../toolbars-ui/index.js";
import { FLOATING_PLUGIN_TOOLBAR } from "./../toolbars-v3/index.js";
import { VIDEO_BUTTONS, VIDEO_REPLACE_MODAL_ID, VIDEO_SETTINGS_MODAL_ID } from "./constants.js";
import { InsertModal } from "./modals/InsertModal.js";
import { SettingsModal } from "./modals/SettingsModal.js";
const getToolbarButtons = (config, services) => {
  const {
    disableDownloadDefault,
    enableCustomUploadOnMobile,
    getVideoUrl,
    handleFileSelection,
    handleFileUpload,
    onVideoSelected
  } = config || {};
  const {
    modals,
    context: { isMobile }
  } = services;
  const modalBaseProps = {
    disableDownloadDefault,
    enableCustomUploadOnMobile,
    getVideoUrl,
    handleFileSelection,
    handleFileUpload,
    onVideoSelected
  };
  const shouldShowSpoiler = () => {
    const spoilerPlugin = services.plugins.asArray().find((plugin) => plugin.getType() === SPOILER_TYPE);
    return spoilerPlugin && (!spoilerPlugin.getConfig().supportedPlugins || spoilerPlugin.getConfig().supportedPlugins.includes(VIDEO_TYPE));
  };
  const settingsVisibilityResolver = {
    id: "IS_VIDEO_SETTINGS_BUTTON_VISIBLE",
    resolve: (content) => {
      if (Array.isArray(content) && content.length > 0) {
        const isCustomVideo = !!content.find((node) => node?.type?.name === Node_Type.VIDEO)?.attrs?.video?.src?.id;
        return shouldShowSpoiler() || isCustomVideo;
      }
      return false;
    }
  };
  return [
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SIZE,
      modal: {
        Component: decorateComponentWithProps(SizePanel, {
          options: ["SMALL", "CONTENT", "FULL_WIDTH"]
        }),
        id: VIDEO_BUTTONS.size
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(NodeSizeButton, { id: VIDEO_BUTTONS.size, toolbarItem })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: getVisibleOnlyOnDesktopResolver(isMobile)
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.ALIGNMENT,
      modal: {
        Component: AlignmentPanel,
        id: VIDEO_BUTTONS.alignment
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(NodeAlignmentButton, { toolbarItem, id: VIDEO_BUTTONS.alignment })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: getVisibleOnlyOnDesktopResolver(isMobile)
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SETTINGS,
      modal: {
        id: VIDEO_SETTINGS_MODAL_ID,
        Component: SettingsModal
      },
      attributes: {
        visible: settingsVisibilityResolver,
        active: {
          id: "IS_VIDEO_SETTINGS_BUTTON_ACTIVE",
          resolve: (_, { modals: modals2 }) => Boolean(modals2.getModal(VIDEO_SETTINGS_MODAL_ID))
        }
      },
      command: ({ isMobile: isMobile2, referenceElement, attributes: { selectedNode } }) => {
        modals?.togglePluginPanel({
          id: VIDEO_SETTINGS_MODAL_ID,
          Component: SettingsModal,
          componentProps: {
            nodeId: selectedNode.attrs.id
          },
          isMobile: isMobile2,
          positioning: {
            referenceElement: referenceElement?.closest(`[data-hook~=${FLOATING_PLUGIN_TOOLBAR}]`) ?? referenceElement,
            placement: "right-start"
          },
          focusReturnElement: referenceElement
        });
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: settingsVisibilityResolver
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.REPLACE,
      attributes: {
        active: {
          id: "IS_VIDEO_REPLACE_BUTTON_ACTIVE",
          resolve: (_, { modals: modals2 }) => Boolean(modals2.getModal(VIDEO_REPLACE_MODAL_ID))
        }
      },
      command: ({ isMobile: isMobile2, referenceElement, attributes: { selectedNode } }) => {
        const {
          video: { src },
          id
        } = selectedNode.attrs;
        const videoSrc = src.url ? { url: src.url } : src.id ? { id: src.id } : {};
        modals?.togglePluginPanel({
          id: VIDEO_REPLACE_MODAL_ID,
          Component: InsertModal,
          componentProps: {
            modalId: VIDEO_REPLACE_MODAL_ID,
            componentData: { video: { src: videoSrc } },
            nodeId: id,
            ...modalBaseProps
          },
          isMobile: isMobile2,
          positioning: {
            referenceElement,
            placement: "bottom"
          },
          mobileLayout: "drawer"
        });
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.DELETE,
      renderer: (toolbarItem) => {
        return /* @__PURE__ */ React.createElement(DeleteButton, { toolbarItem });
      },
      command: (data) => {
        const figures = data.tiptapEditor.$nodes(TIPTAP_FIGURE_TYPE);
        const selectedFigure = figures?.find((f) => {
          return f.firstChild?.node.attrs.id === data.attributes.selectedNode.attrs.id;
        });
        if (selectedFigure) {
          data.tiptapEditor.chain().focus().deleteNode(selectedFigure.attributes.id).run();
        }
      }
    }
  ];
};
export {
  getToolbarButtons
};
//# sourceMappingURL=getToolbarButtons.js.map
